export default __webpack_public_path__ + "static/media/Rock 1.1a15219b.png";